import React from 'react'
import { Modal} from 'react-bootstrap'
import Back from 'assets/images/svg/back_blue.svg';
import { useTranslation } from 'react-i18next';

const DeleteMethod = ({show,onDelete, onHide,...props}) => {
    const { t } = useTranslation("browse-apps");

  return (
    <div>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={show}
                onHide={onHide}
                className='all-modal changeNumber'
            >
                <Modal.Body>
                    <div className='header'>
                    <img src={Back} alt='back' onClick={onHide}/>
                        <h1>  {t("paymentDetails.deleteCard")}</h1>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <p>  {t("paymentDetails.confirmDelete")}</p>
                        </div>

               
                        <div className='col-12'>
                            <button className='btn-blue' onClick={onDelete}>  {t("paymentDetails.delete")}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
  )
}

export default DeleteMethod